var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full"},[_c('Header',{attrs:{"title":"Control Center","description":"  Access all core features of your project in control center. Find\n        options to manage content, accessbility, payments & projects logs\n        in this tab."}}),_c('EcommerceList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }